import {ChangeDetectionStrategy, ChangeDetectorRef, Component} from '@angular/core';
import {MemberModel} from '../../../../models/user.model';
import {MemberService} from '../../../../services/member.service';
import {HelpersService} from '../../../../services/helpers.service';
import {LayoutDataService} from '../../services/lyaout-data.service';
import {WidgetsService} from '../../../widgets/services/widgets.service';
import {Router} from "@angular/router";
import { DialogsMTService } from '../../../../services/modal/dialogs-mt.service';
import { TranslateService } from '@ngx-translate/core';
import { FormControl } from '@angular/forms';
import { filter, Subscription } from 'rxjs';

@Component({
    selector: 'app-m-layout-header',
    templateUrl: './layout-header.component.html',
    styleUrl: './layout-header.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppLayoutHeaderComponent {
    private subs = new Subscription()
	public userProfile:MemberModel & {full_name?:string}|null=null
	public showWidgets:boolean = false
	public isUserProfileHidden:boolean = true
    public searchControl = new FormControl()
	constructor(
		private translateService:TranslateService,
		private memberService:MemberService,
		private widgetsService:WidgetsService,
		private dialogsMTService:DialogsMTService,
		private helpersService:HelpersService,
		private cds:ChangeDetectorRef,
		private layoutDataService: LayoutDataService,
		private widgetService: WidgetsService,
		private router: Router,
	) {
	}
    ngOnDestroy(): void {
        this.subs.unsubscribe()
    }
	ngOnInit(): void {
		this.memberService.getCurrentMember().then(data=>{
			this.userProfile = structuredClone(data);
			this.userProfile.full_name = this.helpersService.shortFullName(this.userProfile,true);
			this.cds.detectChanges();
		})
        this.subs.add(
            this.searchControl.valueChanges
            //.pipe(filter(str=>str.length>1))
            .subscribe(str=>this.layoutDataService.subGlobalSearch.next(str))
        )
	}

	detectChanges(){
		setTimeout(() => {
			this.cds.detectChanges();
		}, 100);
	}

	createWidgetInstruct() {
		this.widgetService.subWidgetNewCreate.next(true);
	}

	navToIndex() {
		this.router.navigate(['account', 'index']);
	}

	toggleMenuPanel() {
		this.layoutDataService.bSubToggleMenuPanel.next(!this.layoutDataService.bSubToggleMenuPanel.value);
	}

	toggleUserProfile(){
		this.isUserProfileHidden = !this.isUserProfileHidden;
	}

	toggleWidgetData(){
		this.showWidgets = !this.showWidgets
		this.widgetsService.subShowWidgets.next(this.showWidgets);
	}

	toggleNotifications() {
    let actionHeader = this.translateService.instant('MODALS.HEADERS.NOTIFICATIONS')
    let actionBody = this.translateService.instant('EMPTY_LISTS.NOTIFICATIONS')
    this.dialogsMTService.setNotification({actionHeader:actionHeader, actionBody:actionBody})
	}
  goToBank() {
    let actionHeader = this.translateService.instant('CONTRACTS.CARD.BANK_PRODUCTS')
    this.dialogsMTService.setNotification({actionHeader: actionHeader, actionBody:''})
    
  }
	selectCompany (){
		this.userProfile ? this.layoutDataService.selectCompany(this.userProfile) : null;
	}

	logout() {
		this.memberService.logout();
	}
}
